import { useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';

export const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { name: 'Services', href: '#services' },
    { name: 'Portfolio', href: '#portfolio' },
    { name: 'Why Us', href: '#trust' },
    { name: 'Testimonials', href: '#testimonials' },
    { name: 'Contact', href: '#contact' },
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6 }}
      className="fixed top-0 left-0 right-0 z-50 px-6 py-4"
      data-testid="navigation"
    >
      <div className="max-w-7xl mx-auto">
        <div className="glass-card rounded-full px-6 py-3 flex items-center justify-between">
          <motion.div
            className="text-xl font-black tracking-tight"
            whileHover={{ scale: 1.05 }}
            data-testid="logo"
          >
            <span className="bg-gradient-to-r from-white to-zinc-400 bg-clip-text text-transparent">
              NEXUS
            </span>
            <span className="text-[#007AFF] ml-1">•</span>
          </motion.div>

          <div className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <button
                key={item.name}
                onClick={() => scrollToSection(item.href)}
                className="text-sm text-zinc-400 hover:text-white transition-colors cursor-hover"
                data-testid={`nav-${item.name.toLowerCase()}`}
              >
                {item.name}
              </button>
            ))}
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => scrollToSection('#contact')}
              className="bg-[#007AFF] text-white px-6 py-2 rounded-full text-sm font-semibold hover:bg-[#0066DD] transition-colors cursor-hover"
              data-testid="nav-cta-button"
            >
              Book a Call
            </motion.button>
          </div>

          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-white cursor-hover"
            data-testid="mobile-menu-button"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {isOpen && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="md:hidden mt-4 glass-card rounded-2xl p-6 max-w-7xl mx-auto"
          data-testid="mobile-menu"
        >
          {navItems.map((item) => (
            <button
              key={item.name}
              onClick={() => scrollToSection(item.href)}
              className="block w-full text-left py-3 text-zinc-400 hover:text-white transition-colors cursor-hover"
              data-testid={`mobile-nav-${item.name.toLowerCase()}`}
            >
              {item.name}
            </button>
          ))}
          <button
            onClick={() => scrollToSection('#contact')}
            className="w-full bg-[#007AFF] text-white px-6 py-3 rounded-full text-sm font-semibold hover:bg-[#0066DD] transition-colors mt-4 cursor-hover"
            data-testid="mobile-nav-cta"
          >
            Book a Call
          </button>
        </motion.div>
      )}
    </motion.nav>
  );
};